/* eslint-disable max-len */
import React from 'react';

const DateInput = ({ date, onDateChange, labeltext, dateFormat ,idPrefix}) => {
    // Determine input order and placeholders based on dateFormat
    const [firstField, secondField, thirdField, firstPlaceholder, secondPlaceholder] =
        dateFormat === 'mm/dd/yyyy'
            ? ['month', 'day', 'year', 'MM', 'DD']
            : ['day', 'month', 'year', 'DD', 'MM'];

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        onDateChange({ ...date, [field]: value });

        // Dynamically handle focus shifting based on field order
        if (field === firstField && value.length === 2) {
            document.getElementById(`${idPrefix}${secondField.charAt(0).toUpperCase() + secondField.slice(1)}Input`).focus();
        } else if (field === secondField && value.length === 2) {
            document.getElementById(`${idPrefix}YearInput`).focus();
        }
    };

    return (
        <div>
            <label className='text-xs font-normal text-[#000000] mb-1 more-lines'>{labeltext}</label>
            <div className="flex items-center border border-[#C5C9DA] rounded-lg px-2 py-1.5">
                <input
                    id={`${idPrefix}${firstField.charAt(0).toUpperCase() + firstField.slice(1)}Input`}
                    type="text"
                    maxLength="2"
                    placeholder={firstPlaceholder}
                    value={date[firstField] || ''}
                    onChange={(e) => handleInputChange(e, firstField)}
                    autoComplete='off'
                    className="w-[24px] text-sm font-normal text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none"
                />
                /
                <input
                    id={`${idPrefix}${secondField.charAt(0).toUpperCase() + secondField.slice(1)}Input`}
                    type="text"
                    maxLength="2"
                    autoComplete='off'
                    placeholder={secondPlaceholder}
                    value={date[secondField] || ''}
                    onChange={(e) => handleInputChange(e, secondField)}
                    className="w-[30px] text-sm font-normal text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none pl-1"
                />
                /
                <input
                    id={`${idPrefix}YearInput`}
                    type="text"
                    maxLength="4"
                    autoComplete='off'
                    placeholder="YYYY"
                    value={date[thirdField] || ''}
                    onChange={(e) => handleInputChange(e, thirdField)}
                    className="w-[60px] text-sm font-normal text-[#000000] disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-xs outline-none appearance-none pl-1"
                />
            </div>
        </div>
    );
};

export default DateInput;
